import gql from "graphql-tag"
import fullPerksSaga from "../queries/fragments/fullPerksSaga"

const query = gql`
  mutation PerksSagaPay($sagaId: ID!, $details: PerksSagaPayInput!) {
    perksSagaPay(sagaId: $sagaId, details: $details) {
      ...fullPerksSaga
    }
  }
  ${fullPerksSaga}
`

export const toString = query.loc.source.body

export default query
